import { cn } from '@/lib/utils'

const FinishedStepIcon = () => (
    <span className="tw:bg-green-500 tw:rounded-full tw:size-4 tw:min-h-4 tw:min-w-4 tw:flex tw:items-center tw:justify-center">
        <svg width="8" height="7" viewBox="0 0 8 7" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M1 4.22727L2.10363 5.565C2.50361 6.04983 3.24639 6.04982 3.64637 5.565L7 1.5"
                stroke="white"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    </span>
)

const ProgressIcon = ({ progress }) => (
    <div
        style={{ '--p': `${progress}%` }}
        className={cn(
            'tw:relative tw:size-4 tw:border-2 tw:border-green-500 tw:min-h-4 tw:min-w-4',
            'tw:rounded-full tw:bg-[conic-gradient(from_0deg,_#32C05A_var(--p),_transparent_var(--p))]',
        )}
    >
        <div className="tw:absolute tw:inset-4 tw:rounded-full tw:bg-slate-900"></div>
    </div>
)

const InitialStepStatusIcon = () => (
    <span className="tw:border-2 tw:border-gray-200 tw:rounded-full tw:size-4 tw:min-h-4 tw:min-w-4" />
)

const EmptyGreenCircleIcon = () => (
    <span className="tw:border-2 tw:border-green-500 tw:rounded-full tw:size-4 tw:min-h-4 tw:min-w-4" />
)

const StepStatusIcon = ({ showGreenCircle, progress }) => {
    if (progress >= 1) return <FinishedStepIcon />
    if (showGreenCircle) return <EmptyGreenCircleIcon />
    if (progress > 0) return <ProgressIcon progress={progress * 100} />
    return <InitialStepStatusIcon />
}

const ParentStepStatusIcon = ({ children, currentStepName, progress }) => {
    const hasActiveChild = children.some((child) => child.name === currentStepName)
    const allChildrenCompleted = children.every((child) => child.complete === 1)

    if (progress >= 1) return <FinishedStepIcon />
    if (hasActiveChild && progress === 0) {
        return <span className="tw:border-2 tw:border-green-500 tw:rounded-full tw:size-4 tw:min-h-4 tw:min-w-4" />
    }
    if (hasActiveChild && progress > 0) return <ProgressIcon progress={progress * 100} />
    if (allChildrenCompleted) return <FinishedStepIcon />
    return <InitialStepStatusIcon />
}

export { FinishedStepIcon, ProgressIcon, InitialStepStatusIcon, StepStatusIcon, ParentStepStatusIcon }
